import React from 'react';
import dynamic from 'next/dynamic';
import useAboutData from './utils/useAboutData';
import SectionWrapper from '@components/Shared/SectionWrapper';
import CenteredFlex from '@components/Shared/CenteredFlex';
import SEO from '@components/SEO';
import { MAIN_URL } from '@src/commons/constants';
import {
  ABOUT_ME_PAGE_DESC,
  ABOUT_ME_PAGE_TITLE,
} from '@src/commons/seoConstants';

const DynamicAboutSection = dynamic(
  () => import('@components/About/AboutSection')
);

const DynamicAboutQuote = dynamic(() => import('@components/About/AboutQuote'));

const About: ComponentWithDataHooks = () => {
  const {
    aboutMeData: {
      topImage,
      aboutMeTopContentRaw,
      aboutMeQuoteRaw,
      bottomImage,
      aboutMeBottomContentRaw,
    },
    mainImageUrl,
  } = useAboutData();
  return (
    <>
      <SEO
        title={ABOUT_ME_PAGE_TITLE}
        description={ABOUT_ME_PAGE_DESC}
        url={`${MAIN_URL}/about`}
        image={mainImageUrl}
      />
      <SectionWrapper pt={28}>
        <CenteredFlex direction="column">
          <CenteredFlex direction="column">
            <DynamicAboutSection
              image={topImage}
              text={aboutMeTopContentRaw}
              mb={24}
            />
            <DynamicAboutQuote text={aboutMeQuoteRaw} />
            <DynamicAboutSection
              image={bottomImage}
              text={aboutMeBottomContentRaw}
              reverse
              mt={24}
              mb={20}
            />
          </CenteredFlex>
        </CenteredFlex>
      </SectionWrapper>
    </>
  );
};

About.dataHooks = [useAboutData];

export default About;
